// import { useState } from 'react';
import { Button } from '../../../ui/button';
import { Badge } from '../../../ui/badge';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../../ui/dialog';
import {
  // CheckCircle2,
  // XCircle,
  // ArrowRight,
  Activity,
  User,
  Clock,
  X,
  ArrowRight,
  // DollarSign,
  // FileText,
  // AlertTriangle
} from 'lucide-react';
import { StatusHistory } from '../../../types/visa';
import { formatDateTime } from '../../../utils/commonutils';

// interface ActivityLog {
//   id: string;
//   action: string;
//   description: string;
//   timestamp: string;
//   user: string;
//   statusCard?: string;
//   remark?: string;
//   oldValue?: string;
//   newValue?: string;
//   type?: 'approval' | 'rejection' | 'movement' | 'modification' | 'document';
// }

interface ActivityLogsPageProps {
  applicantId?: string;
  visaId?: number | string;
  statushisLoader?: boolean;
  selectedApplicantForLogs?: StatusHistory[];   // ✅ Correct type
  open: boolean;
  onClose: () => void;
}

// Enhanced mock data with document rejections and fee changes
// const mockActivityLogs: ActivityLog[] = [
//   {
//     id: 'log1',
//     action: 'Application Created',
//     description: 'Visa application created and submitted by Tour Operator',
//     timestamp: '18-01-2025 10:15 AM',
//     user: 'Al-Mustafa Tours',
//     statusCard: 'New Application',
//     type: 'approval'
//   },
//   {
//     id: 'log2',
//     action: 'Moved to Visa Document Required',
//     description: 'Application moved to Visa Document Required for fee collection',
//     timestamp: '19-01-2025 09:30 AM',
//     user: 'System',
//     statusCard: 'Visa Document Required',
//     type: 'movement'
//   },
//   {
//     id: 'log3',
//     action: 'Documents Uploaded',
//     description: 'All required documents uploaded by Tour Operator',
//     timestamp: '20-01-2025 11:45 AM',
//     user: 'Al-Mustafa Tours',
//     statusCard: 'Visa Document Required',
//     type: 'document'
//   },
//   {
//     id: 'log4',
//     action: 'Document Rejected - Passport Copy',
//     description: 'Passport copy rejected due to poor quality',
//     timestamp: '20-01-2025 12:30 PM',
//     user: 'Admin User',
//     statusCard: 'Visa Document Required',
//     remark: 'Image quality is too low. Please upload a clear, high-resolution scan of the passport biodata page.',
//     type: 'rejection'
//   },
//   {
//     id: 'log5',
//     action: 'Document Re-uploaded - Passport Copy',
//     description: 'Passport copy re-uploaded with better quality',
//     timestamp: '20-01-2025 01:15 PM',
//     user: 'Al-Mustafa Tours',
//     statusCard: 'Visa Document Required',
//     type: 'document'
//   },
//   {
//     id: 'log6',
//     action: 'Document Approved - Passport Copy',
//     description: 'Passport copy approved by admin',
//     timestamp: '20-01-2025 01:45 PM',
//     user: 'Admin User',
//     statusCard: 'Visa Document Required',
//     type: 'approval'
//   },
//   {
//     id: 'log8',
//     action: 'Fees Collected',
//     description: 'Visa fee of $120 collected and verified',
//     timestamp: '20-01-2025 02:20 PM',
//     user: 'Admin User',
//     statusCard: 'Visa Document Required',
//     type: 'approval'
//   },
//   {
//     id: 'log9',
//     action: 'Moved to To Be Sent for Processing',
//     description: 'Application approved and ready to be sent for processing',
//     timestamp: '20-01-2025 03:15 PM',
//     user: 'Admin User',
//     statusCard: 'To Be Sent for Processing',
//     type: 'movement'
//   },
//   {
//     id: 'log10',
//     action: 'Documents Reviewed',
//     description: 'All documents reviewed and approved by admin',
//     timestamp: '21-01-2025 10:00 AM',
//     user: 'Admin User',
//     statusCard: 'To Be Sent for Processing',
//     type: 'approval'
//   },
//   {
//     id: 'log11',
//     action: 'Sent for Processing',
//     description: 'Application sent to Muwafiqa for visa processing',
//     timestamp: '21-01-2025 11:30 AM',
//     user: 'Admin User',
//     statusCard: 'To Be Sent for Processing',
//     type: 'movement'
//   },
//   {
//     id: 'log12',
//     action: 'Moved to Update Applicant Status',
//     description: 'Application received from Muwafiqa and pending status update',
//     timestamp: '22-01-2025 09:00 AM',
//     user: 'System',
//     statusCard: 'Update Applicant Status',
//     type: 'movement'
//   },
//   {
//     id: 'log13',
//     action: 'Status Updated - Approved',
//     description: 'Visa application approved by Muwafiqa',
//     timestamp: '22-01-2025 02:15 PM',
//     user: 'Admin User',
//     statusCard: 'Update Applicant Status',
//     type: 'approval'
//   },
//   {
//     id: 'log14',
//     action: 'Moved to Completed',
//     description: 'Application successfully completed and moved to completed status',
//     timestamp: '22-01-2025 02:30 PM',
//     user: 'Admin User',
//     statusCard: 'Completed',
//     type: 'movement'
//   }
// ];


export const ActivityLogsPage = ({ applicantId, visaId = 'VISA-2025001', statushisLoader, selectedApplicantForLogs, open, onClose }: ActivityLogsPageProps) => {
  // const [activityLogs] = useState(mockActivityLogs);

  // const getActivityIcon = (type?: string) => {
  //   switch (type) {
  //     case 'approval':
  //       return <CheckCircle2 className="w-4 h-4 text-green-600" />;
  //     case 'rejection':
  //       return <XCircle className="w-4 h-4 text-red-600" />;
  //     case 'movement':
  //       return <ArrowRight className="w-4 h-4 text-blue-600" />;
  //     case 'modification':
  //       return <DollarSign className="w-4 h-4 text-orange-600" />;
  //     case 'document':
  //       return <FileText className="w-4 h-4 text-purple-600" />;
  //     default:
  //       return <Activity className="w-4 h-4 text-gray-600" />;
  //   }
  // };

  // const getActivityDotColor = (type?: string) => {
  //   switch (type) {
  //     case 'approval':
  //       return 'bg-green-500';
  //     case 'rejection':
  //       return 'bg-red-500';
  //     case 'movement':
  //       return 'bg-blue-500';
  //     case 'modification':
  //       return 'bg-orange-500';
  //     case 'document':
  //       return 'bg-purple-500';
  //     default:
  //       return 'bg-gray-400';
  //   }
  // };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="w-[95vw] max-w-[1100px] xl:max-w-[1100px] max-h-[95vh] p-0 rounded-xl overflow-hidden"
        style={{ padding: "0px", gap: "0px" }}
      >
        {/* HEADER */}
        <DialogHeader className="px-4 sm:px-6 py-2 border-b bg-white sticky top-0 z-10">
          <div className="flex items-center justify-between">
            <div className="relative group">
              <DialogTitle className="flex items-center gap-2 text-base sm:text-lg font-semibold cursor-pointer">
                <Activity className="w-5 h-5 text-violet-600" />
                Activity Logs
              </DialogTitle>

              <div className="absolute left-0 top-full mt-2 whitespace-nowrap bg-gray-900 text-white text-xs px-3 py-2 rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-50">
                Complete history of status changes, approvals, and movements for this application check
              </div>
            </div>

            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="rounded-full hover:bg-gray-100"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </DialogHeader>

        {/* BODY */}
        <div className="px-3 sm:px-6 py-4 space-y-4 max-h-[calc(95vh-80px)] overflow-y-auto bg-gray-50">
          {selectedApplicantForLogs?.map((log, index) => (
            <div key={log.statusHistoryId} className="relative pl-5 sm:pl-6">
              
              {/* Timeline line */}
              {index !== selectedApplicantForLogs.length - 1 && (
                <div className="absolute left-[7px] sm:left-[8px] top-6 bottom-0 w-[2px] bg-gray-200" />
              )}

              {/* Dot */}
              <div className="absolute left-0 top-4 w-3 h-3 sm:w-3.5 sm:h-3.5 rounded-full bg-green-500 ring-4 ring-green-100" />

              {/* CARD */}
              <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-4 shadow-sm hover:shadow-md transition-all">

                {/* TOP ROW (FIXED FOR MOBILE) */}
                <div className="flex flex-col sm:flex-row sm:items-center mb-2 gap-1 sm:gap-2">
                  
                  {log.messageTitle && (
                    <p className="text-xs text-gray-900 break-words">
                      <span className="text-gray-400">Title: </span>
                      <span className="font-semibold">{log.messageTitle}</span>
                    </p>
                  )}

                  {log.messageTitle && log.message && (
                    <span className="hidden sm:inline text-gray-300 leading-none">•</span>
                  )}

                  {log.message && (
                    <p className="text-xs text-gray-600 break-words">
                      <span className="text-gray-400">Message: </span>
                      {log.message}
                    </p>
                  )}
                </div>

                {/* STATUS FLOW */}
                <div className="flex sm:flex-row flex-col sm:justify-between gap-2">

                  {/* STATUS (mobile scroll only) */}
                  <div className="
                    flex items-center gap-2 whitespace-nowrap
                    overflow-x-auto sm:overflow-visible
                    hide-scrollbar
                  ">

                    {log.fromStatusCode &&
                      log.toStatusCode &&
                      log.fromStatusCode !== log.toStatusCode && (
                        <>
                          <span className="text-xs text-gray-400 shrink-0">From</span>

                          <span className="px-2.5 py-1 text-xs rounded-full bg-gray-100 text-gray-600 font-medium shrink-0">
                            {log.fromStatusCode}
                          </span>

                          <ArrowRight className="w-4 h-4 text-gray-300 shrink-0" />

                          <span className="text-xs text-gray-400 shrink-0">To</span>

                          <span className="px-2.5 py-1 text-xs rounded-full bg-green-100 text-green-700 font-semibold shrink-0">
                            {log.toStatusCode}
                          </span>
                        </>
                      )}

                    {log.fromStatusCode === log.toStatusCode && log.toStatusCode && (
                      <Badge
                        variant="outline"
                        className="text-xs whitespace-nowrap"
                        style={{ borderColor: "#5B9BD5", color: "#5B9BD5" }}
                      >
                        {log.toStatusCode}
                      </Badge>
                    )}
                  </div>

                  {/* TIME */}
                  <div className="flex items-center gap-1 text-xs text-gray-400 sm:ml-auto">
                    <Clock className="w-3.5 h-3.5" />
                    {formatDateTime(log?.changedOn)}
                  </div>
                </div>

                {/* FOOTER */}
                <div className="flex items-center justify-between text-xs text-gray-400 mt-3 pt-3 border-t">
                  <span className="flex items-center gap-1">
                    <User className="w-3.5 h-3.5" />
                    {log.changedByFullName ?? "System"}
                  </span>
                </div>

              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};